import * as React from 'react'

function FormCheckRequired() {
  return <abbr className="text-danger mr-1">*</abbr> // [27379](https://pm.mvlabs.it/issues/27379)
}

export default FormCheckRequired
